import React, { useContext, useEffect, useState } from "react";
import Logo from "../../src/pics/LRIFullLogoTeal.png";
import { Navbar, Nav, Image } from "react-bootstrap";
import "bootstrap/dist/css/bootstrap.min.css";
import { AuthContext } from "../context/authContext";
import { FetchContext } from "../context/FetchContext";

import { useNavigate, useLocation } from "react-router-dom";

const AlamarkNav = () => {
    const history = useNavigate();
    const loc = useLocation()
    const auth = useContext(AuthContext);
    const { authState } = auth;
    const fetchContext = useContext(FetchContext);
    const [faqLink, setFaqLink] = useState('');

    useEffect(() => {
        if (!authState.isAuthenticated) return;
        fetchContext.authAxios.get("/faqlink").then((res) => {
            setFaqLink(res.data.faqLink || '');
        }).catch((error) => {
            console.error("Error fetching FAQ link:", error);
        });
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [authState.isAuthenticated]);

    function goToLink(link) {
        // console.log(link)
        history(`/${link}`)
    }
    return (
        <>
            <Navbar
                collapseOnSelect
                expand="lg"
                className="px-3 app-navbar"
                variant="light"
                bg="white"
            >
                <Navbar.Brand>
                    <Image src={Logo} style={{ height: '50px', marginLeft: "10px" }} fluid />
                </Navbar.Brand>

                {authState.isAuthenticated ? <>
                    <Navbar.Toggle aria-controls="responsive-navbar-nav" className="nav-toggle" />
                    <Navbar.Collapse id="responsive-navbar-nav" className="justify-content-end">
                        <Nav className="nav-primary-group">
                            {loc.pathname === '/projects' ? null : <Nav.Link className="nav-link-primary">
                                <button className="btn nav-btn-primary" onClick={() => goToLink("projects")}>
                                    Projects
                                </button>
                            </Nav.Link>}
                            {loc.pathname === '/invoices' ? null :
                                <Nav.Link className="nav-link-primary">
                                    <button className="btn nav-btn-primary" onClick={() => goToLink("invoices")}>
                                        Invoices
                                    </button>
                                </Nav.Link>}
                        </Nav>

                        <span className="nav-divider d-none d-lg-block" aria-hidden="true" />

                        <Nav className="nav-utility-group">
                            <Nav.Link className="nav-link-utility">
                                <button
                                    className="btn nav-btn-utility"
                                    disabled={!faqLink}
                                    onClick={() => window.open(faqLink, '_blank', 'noopener,noreferrer')}
                                >
                                    Key Info
                                </button>
                            </Nav.Link>
                            <Nav.Link className="nav-link-utility">
                                <button
                                    className="btn nav-btn-utility"
                                    onClick={() => window.open("https://www.lrirightnow.com", '_blank', 'noopener,noreferrer')}
                                >
                                    LRIrightnow Libraries
                                </button>
                            </Nav.Link>
                            <Nav.Link className="nav-link-utility">
                                <button
                                    className="btn nav-btn-utility"
                                    onClick={() => window.open("http://lricitc.com", '_blank', 'noopener,noreferrer')}
                                >
                                    Consultant Website
                                </button>
                            </Nav.Link>
                        </Nav>

                        <Nav>
                            <Nav.Link className="nav-link-logout">
                                <button className="btn nav-btn-logout" onClick={auth.logout}>
                                    Log Out
                                </button>
                            </Nav.Link>
                        </Nav>
                    </Navbar.Collapse>
                </> : (
                    ""
                )}


            </Navbar>
        </>
    );
}

export default AlamarkNav;
